import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "./client";
import type { ValidationResult } from "../types";

export interface ValidateParams {
  datasource: string;
  lon: number;
  lat: number;
  radius: number;
  mode: "wave" | "wind";
}

export function useValidation(params: ValidateParams | null) {
  return useQuery<ValidationResult>({
    queryKey: ["validate", params],
    queryFn: () =>
      apiFetch<ValidationResult>("/api/validate", {
        datasource: params!.datasource,
        lon: params!.lon,
        lat: params!.lat,
        radius: params!.radius,
        mode: params!.mode,
      }),
    enabled: params != null,
    // Cache validation result for the session — re-running the same query
    // would take another minute and the satellite data doesn't change.
    staleTime: Infinity,
    gcTime: 60 * 60 * 1000,
    retry: false,
  });
}
